import { render, staticRenderFns } from "./review-details.vue?vue&type=template&id=6991e4f7&scoped=true&"
import script from "./review-details.vue?vue&type=script&lang=js&"
export * from "./review-details.vue?vue&type=script&lang=js&"
import style0 from "./review-details.vue?vue&type=style&index=0&id=6991e4f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6991e4f7",
  null
  
)

export default component.exports